import { render, staticRenderFns } from "./shippingDriversConfig.vue?vue&type=template&id=4ed9fdc5&scoped=true"
import script from "./shippingDriversConfig.vue?vue&type=script&lang=js"
export * from "./shippingDriversConfig.vue?vue&type=script&lang=js"
import style0 from "./shippingDriversConfig.vue?vue&type=style&index=0&id=4ed9fdc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed9fdc5",
  null
  
)

export default component.exports